function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#201D1A",
  fillRule: "nonzero",
  d: "M93.2 140v-21h14.4V93.6H93.2V0H59.8L0 97.4V119h61v21h32.2zM61 93.6H30.4L61 44.8v48.8zM371.2 140v-21h14.4V93.6h-14.4V0h-33.4L278 97.4V119h61v21h32.2zM339 93.6h-30.6L339 44.8v48.8z",
  transform: "translate(-447 -316) translate(447 316)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-447 -316) translate(447 316) translate(124.8)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#201D1A"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 35c19.333 0 35 15.67 35 34.995C105 89.325 89.333 105 70 105c-19.327 0-35-15.675-35-35.005C35 50.669 50.673 35 70 35zm-.003 21.229c-7.604 0-13.77 6.16-13.77 13.767 0 7.61 6.166 13.774 13.77 13.774 7.61 0 13.77-6.165 13.77-13.774 0-7.605-6.16-13.767-13.77-13.767zm.002 2.104c6.434 0 11.668 5.236 11.668 11.67 0 6.43-5.234 11.664-11.668 11.664-6.434 0-11.666-5.233-11.666-11.664 0-6.435 5.23-11.67 11.666-11.67zm0 1.347c-5.69 0-10.32 4.63-10.32 10.324 0 5.688 4.629 10.317 10.32 10.317 5.693 0 10.323-4.628 10.323-10.317 0-5.695-4.63-10.324-10.323-10.324zm0 4.487c3.218 0 5.834 2.615 5.834 5.832 0 3.215-2.616 5.834-5.834 5.834-3.216 0-5.832-2.619-5.832-5.834 0-3.215 2.616-5.832 5.832-5.832zm0 1.408c-2.44 0-4.426 1.984-4.426 4.424 0 2.442 1.985 4.427 4.426 4.427 2.44 0 4.428-1.985 4.428-4.427 0-2.44-1.988-4.424-4.428-4.424zm.09-27.515c-.222-.039-.449-.04-.671-.003-1.09.18-1.827 1.21-1.648 2.299l2.273 13.77s1.5-.146 2.924.575l7.644-11.99c.142-.222.238-.47.284-.73.19-1.088-.537-2.124-1.626-2.314z"
})))))));

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 140,
    viewBox: "0 0 386 140",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.d7199882.svg";
export { ForwardRef as ReactComponent };